import { jsx as _jsx } from "react/jsx-runtime";
import { Drawer as DrawerCom, Wrapper } from '@mademine/components';
var Drawer = function (_a) {
    var children = _a.children, onClose = _a.onClose, className = _a.className;
    return (_jsx(Wrapper, { position: "absolute", className: "_sz-z-[12]", children: _jsx(DrawerCom, { onClose: onClose, mask: true, className: "".concat(className), children: children }) }));
};
export default Drawer;
